import styled from "styled-components";
import {
  Button as AntButton,
  Typography,
  Form as AntForm,
  Input as AntInput,
} from 'antd';
import { AuthLogo, AuthBg } from "@assets/auth";

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  background-image: url(${AuthBg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;

  .ant-btn-primary {
    width: 100%;
    height: 56px;
    color: #FFF;
  }

  position: relative;
`;

export const Heading = styled.div`
  width: 100%;
  height: 250px;

  display: flex;
  flex-direction: column;
  justify-content: baseline;
  align-items: center;
`

export const NavContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  width: calc(100%);
  padding: 0 16px;
  flex-direction: row;
  justify-content: ${props => props.backKey ? 'end' : 'space-between'};
  align-items: center;
  height: 37px;/* need to add this to be the same height with nav from other auth pages */
  margin: 40px 0 0 0;
`;

export const ArrowIconWrapper = styled.div`
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 32px;
  background: rgba(0, 0, 0, 0.20);
  cursor: pointer;
`
export const BackButton = styled.div`
  padding: 8px 26px;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const SkipButton = styled(AntButton)`
  padding: 12px 27px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 36px;
  border-radius: 21px;
  background: rgba(0, 0, 0, 0.20);

  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

export const Logo = styled(AuthLogo)`
  margin: -5px auto 0 auto;
  width: 218px;
  height: 236px;
`
export const Title = styled(Typography.Title)`
  color: #FFF !important;
  font-size: 24px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  margin: 24px 0 0 0;
`

export const ContentContainer = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto 24px;
  padding: 0 16px 0;
`

export const Form = styled(AntForm)`
  margin: 24px 0 0 0;
  width: 100%;
  text-align: center;

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 8px;
  }

  .ant-form-item-label {
    margin: 0px 0 2px 8px;
    margin-left: 15px;
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #F8EEFF;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

`;
export const Input = styled(AntInput)`
  -moz-appearance: textfield;
;
  padding-left: 13px;
  height: 55px;
  border-radius: 12px;
  border: 1px solid transparent;
  background: #FFF !important;

  color: #000 !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  &::placeholder {
    color: #9B92BB;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

  }
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const TextButton = styled(AntButton)`
  float: right;
  text-align: right;
  margin: -22px 0 0 0;

  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */

  &:hover{
    color: #FFF !important;
  }
`

export const ORText = styled.div`
  margin: 55px auto 36px !important;
  text-align: center;
  padding: 4px 16px;
  width: fit-content;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.20);

  color: #E5E0F5;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
`

export const ORTextForRegister = styled(ORText)`
  margin: 32px auto !important;
`

export const LoginButton = styled(AntButton)`
  margin: 0px 0 0 0;
  border-radius: 12px;
  width: 100%;
  height: 55px !important;
  background: #9401DA !important;

  color: #FFF !important;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */

  &:hover {
    color: #FFF !important;
    background: #9401DA !important;
  }
`

export const RegisterButton = styled(AntButton)`
  margin: 0 0 20px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.20) !important;

  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: none !important;

  &:hover {
    color: #FFF !important;
    background: rgba(0, 0, 0, 0.20) !important;
  }
`

export const GoToPromoRegisterButton = styled(AntButton)`
  border-radius: 12px;
  background: linear-gradient(180deg, #BE33E8 0%, #6905A6 104.12%);
  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 20px;

  &:hover {
    background: linear-gradient(180deg, #BE33E8 0%, #6905A6 104.12%) !important;
  }
`

export const ContinueButtonWrapper = styled.div`
  .ant-btn-primary:not(.ant-btn-dangerous){
    color: ${props => (props.disabled ? '#49028E' : '#FFF')} !important;
  }
`

export const ContinueButton = styled(AntButton)`

  background: #9401DA !important;
  border: none !important;
  border-radius: 8px !important;
`;


export const TelegramLoginButton = styled.div`
margin-top: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 16px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}}
`;


export const SocialLoginWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const SpaceBetweenTopBottom = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width:100%;
`;

export const SocialRegisterWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const TelegramRegisterButton = styled.div`
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 16px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}}
`;